export default "__VITE_ASSET__C$laiYFr__"